import { API } from "../axios/API";

export const listaCambios = {
  getLastCambios,
  updateLastRead
};

async function getLastCambios (userDni){
  try {
    const response = await API.get(`/listacambios/getlastcambios?userDni=${userDni}`); 
    return response.data;
  }
  catch (err) {
    return err.message;
  }
}

async function updateLastRead (userDni){
  try {
    const response = await API.post("/listacambios/updatelastread", {userDni}); 
    return response.data;
  }
  catch (err) {
    return err.message;
  }
}